import { useEffect, useLayoutEffect, useState } from "react"
import { useLazyQuery } from "react-apollo";
import { useSelector } from "react-redux";
import { getAttributesFromUrl } from "../../../../utils";
import { GET_PRODUCTS_FOR_CATEGORY, GET_PRODUCTS_FOR_COLLECTION } from "../ProductsPagined/ProductsPagined.queries";

export const useDynamicsProductsLoader = (pageContext,) => {

    let myQuery =
        pageContext.type == "category"
            ? GET_PRODUCTS_FOR_CATEGORY
            : GET_PRODUCTS_FOR_COLLECTION

    const {
        itemAnchor,
        after,
        products: reduxProducts,
        url,
    } = useSelector(state => state.anchorListItemReducer)
    // const [dynamicGetProducts, setdynamicGetProducts] = useState({})
    // const [isLoading, setLoading] = useState(false)

    const [cueLoading, setCueLoading] = useState([] as Function[])

    const [getProducts, dynamicGetProducts]: [
        getProducts: Function,
        dynamicGetProducts: { called: boolean; loading: boolean; data: any }
    ] = useLazyQuery(myQuery)


    const getQueryVariables = (
        offsetNbrProduit: number = 0,
        endCursor: string | undefined,
    ) => {
        const attributes = getAttributesFromUrl()

        const nextPageCursor = endCursor || after

        if (pageContext.type == "category") {
            if (pageContext.producTypeId) {
                return {
                    variables: {
                        after: nextPageCursor,
                        attributes: attributes,
                        categories: [pageContext.categoryId],
                        productTypes: [pageContext.producTypeId], // on filtre si besoin avec id parure
                        numberOfItem: 25 + offsetNbrProduit,
                    },
                }
            }
            return {
                variables: {
                    after: nextPageCursor,
                    attributes: attributes,
                    categories: [pageContext.categoryId],
                    numberOfItem: 25 + offsetNbrProduit,
                },
            }
        }
        if (pageContext.type == "collection") {
            return {
                variables: {
                    after: nextPageCursor,
                    attributes: attributes,
                    collections: [pageContext.collectionId],
                    numberOfItem: 25 + offsetNbrProduit,
                },
            }
        }
    }

    useEffect(() => {
        if (!dynamicGetProducts.called) {
            getProductsFiltred()
        }
    }, [dynamicGetProducts])

    useEffect(() => {
        if (!dynamicGetProducts.loading && cueLoading.length > 0) {
            const fn = cueLoading[0]
            const afterQuery = dynamicGetProducts.data?.products?.pageInfo?.endCursor
            const query = { ...getQueryVariables(0, afterQuery) }

            fn && fn(query)
        }
    }, [dynamicGetProducts, cueLoading])

    // useLayoutEffect(() => {
    //     // setLoading(true)
    //     // if (!dynamicGetProducts.loading && dynamicGetProducts.called) {
    //     // setdynamicGetProducts(dynamicGetProducts)
    //     // }
    // }, [dynamicGetProducts])
    const getProductsFiltred = () => {

        let queueLoadingTmp = [...cueLoading]
        queueLoadingTmp.push(query => {
            getProducts(query)
            cueLoading.shift()

            setCueLoading([...cueLoading])
        })
        setCueLoading([...queueLoadingTmp])
    }

    return [dynamicGetProducts, getProductsFiltred]
}
